import { Config, DateEditor, ErrorHandling, getjQuery, TranslationConfig } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import flatpickr from "flatpickr";
import "flatpickr/dist/l10n";
import { getLanguageList } from "./Helpers/LanguageList";
import DOMPurify from "dompurify";

(window as any).flatpickr = flatpickr;
DateEditor.useFlatpickr = true;

// Polyfill jQuery methods removed in 3.3+ but still used by jquery.inputmask
const $ = getjQuery();
if ($) {
    const jq = $ as any;
    if (!jq.isFunction) jq.isFunction = (fn: any) => typeof fn === 'function';
    if (!jq.isArray)    jq.isArray    = (arr: any) => Array.isArray(arr);
    if (!jq.isNumeric)  jq.isNumeric  = (n: any)   => !isNaN(parseFloat(n)) && isFinite(n);
    if (!jq.type)       jq.type       = (obj: any)  => Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
}

Config.rootNamespaces.push('Lederman.ADTSystem');
TranslationConfig.getLanguageList = getLanguageList;
gridDefaults.sanitizer = (globalThis.DOMPurify = DOMPurify).sanitize;

let culture = (document.documentElement?.lang || 'en').toLowerCase();
if (flatpickr.l10ns[culture]) {
    flatpickr.localize(flatpickr.l10ns[culture]);
} else {
    culture = culture.split('-')[0];
    flatpickr.l10ns[culture] && flatpickr.localize(flatpickr.l10ns[culture]);
}

window.onerror = ErrorHandling.runtimeErrorHandler;
window.addEventListener('unhandledrejection', ErrorHandling.unhandledRejectionHandler);
